module.exports = __webpack_public_path__ + "static/img/sup_logo_1.02505c12.png";